import type * as React from 'react';

function SvgDarts(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height="1em" viewBox="0 0 24 24" width="1em" {...props}>
      <path
        d="M11.8206 7.75058C11.9406 7.75058 12.0606 7.77058 12.1806 7.77058L13.7006 6.25058C13.0806 6.07058 12.4306 5.97058 11.7506 5.99058C8.4406 6.13058 5.8706 8.93058 6.0106 12.2406C6.1506 15.5506 8.9506 18.1206 12.2606 17.9806C15.5706 17.8406 18.1406 15.0406 18.0006 11.7306C17.9806 11.2506 17.9006 10.7806 17.7706 10.3306L16.2506 11.8506C16.3206 14.1706 14.5106 16.1306 12.1906 16.2206C9.8506 16.3206 7.8606 14.4906 7.7606 12.1506C7.6606 9.81058 9.4906 7.82058 11.8306 7.72058L11.8206 7.75058Z"
        fill="currentColor"
      />
      <path
        d="M21.6706 9.50058H19.5806C19.8306 10.2606 19.9906 11.0706 20.0006 11.9106C20.0506 16.3206 16.5006 19.9506 12.0906 20.0006C7.6806 20.0506 4.0506 16.5006 4.0006 12.0906C3.9506 7.68058 7.5006 4.05058 11.9106 4.00058C12.8206 4.00058 13.6806 4.15058 14.5006 4.42058V2.33058C13.6706 2.11058 12.8006 1.99058 11.8906 2.00058C6.3706 2.06058 1.9406 6.58058 2.0006 12.1106C2.0606 17.6306 6.5806 22.0606 12.1106 22.0006C17.6306 21.9406 22.0606 17.4206 22.0006 11.8906C22.0006 11.0606 21.8706 10.2606 21.6706 9.50058Z"
        fill="currentColor"
      />
      <path
        d="M12.2806 12.9606L17.7406 7.50058H21.2506C21.5506 7.50058 21.8306 7.32058 21.9406 7.04058C22.0606 6.76058 21.9906 6.44058 21.7806 6.22058L17.7806 2.22058C17.5706 2.01058 17.2406 1.94058 16.9606 2.06058C16.6806 2.18058 16.5006 2.45058 16.5006 2.75058V6.26058L12.1506 10.6106C11.5406 11.2206 11.6006 12.2706 12.2806 12.9606Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgDarts;
